export const iconFontAwesomeHouseholdComputer = (
	<i className="fa-solid fa-computer"></i>
);
